<span *ngIf="icon" istag="icon" class="material-icons icon">{{ icon }}</span>{{ text }}
